module.exports = __webpack_public_path__ + "img/tipbg.11ae5af9.png";